import { Component, Input } from '@angular/core';
import { CodaltComponent } from 'src/app/codalt.component';
import { UserRoleHistory, UserService } from 'src/app/services/user/user.service';

@Component({
    selector: 'app-user-role-history',
    standalone: false,
    templateUrl: './user-role-history.component.html',
    styleUrl: './user-role-history.component.scss',
})
export class UserRoleHistoryComponent extends CodaltComponent {
    loading = true;
    roleHistory: UserRoleHistory[];

    constructor(private userService: UserService) {
        super();
    }

    @Input() set userId(userId: number) {
        this.subscriptions.add(
            this.userService.getUserRoleHistory(userId).subscribe(
                result => {
                    this.roleHistory = result;
                    this.loading = false;
                },
                () => {
                    this.loading = false;
                }
            )
        );
    }
}
